export const KBK_TYPE_ENP = 'ENP';
export const KBK_TYPE_LAND_TAX = 'LAND';
export const KBK_TYPE_TRANSPORT_TAX = 'TRANSPORT';
export const KBK_TYPE_PROPERTY_TAX = 'PROPERTY';
export const KBK_TYPE_INCOME_TAX = 'INCOME';
export const KBK_TYPE_INCOME_DEPOSIT_TAX = 'DEPOSIT';
export const KBK_TYPE_INCOME_PROGRESSIVE_TAX = 'PROGRESSIVE';
export const KBK_TYPE_INCOME_OTHER_TAX = 'OTHER_INCOME';
export const KBK_TYPE_ADM_FINES = 'ADM_PENALTY';
export const KBK_TYPE_NDFL3_INCOME_TAX = 'NDFL3';

const kbkTypes = {
  ndfl3Tax: KBK_TYPE_NDFL3_INCOME_TAX,
  enp: KBK_TYPE_ENP,
  landTax: KBK_TYPE_LAND_TAX,
  transportTax: KBK_TYPE_TRANSPORT_TAX,
  propertyTax: KBK_TYPE_PROPERTY_TAX,
  incomeTax: KBK_TYPE_INCOME_TAX,
  incomeDepositTax: KBK_TYPE_INCOME_DEPOSIT_TAX,
  incomeProgressiveTax: KBK_TYPE_INCOME_PROGRESSIVE_TAX,
  incomeOtherTax: KBK_TYPE_INCOME_OTHER_TAX,
  admFines: KBK_TYPE_ADM_FINES,
};

export const kbkTypesSort = {
  ndfl3Tax: 1,
  enp: 2,
  landTax: 5,
  transportTax: 3,
  propertyTax: 4,
  incomeTax: 6,
  incomeDepositTax: 7,
  incomeProgressiveTax: 8,
  incomeOtherTax: 9,
  admFines: 10,
};

if (process.env.NODE_ENV === 'development') {
  Object.freeze(kbkTypes);
}

export const kbkTaxesTypes = [
  KBK_TYPE_TRANSPORT_TAX,
  KBK_TYPE_PROPERTY_TAX,
  KBK_TYPE_LAND_TAX,
  KBK_TYPE_INCOME_TAX,
  KBK_TYPE_INCOME_DEPOSIT_TAX,
  KBK_TYPE_INCOME_PROGRESSIVE_TAX,
  KBK_TYPE_INCOME_OTHER_TAX,
];

export default kbkTypes;
